import { render } from "./QuestionTen.vue?vue&type=template&id=0a10221a"
import script from "./QuestionTen.vue?vue&type=script&lang=js"
export * from "./QuestionTen.vue?vue&type=script&lang=js"

import "./QuestionTen.vue?vue&type=style&index=0&id=0a10221a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__